import React, { useState, useEffect } from "react";

// React Bootstrap
import { Form } from "react-bootstrap";

// Material UI
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import FormHelperText from "@mui/material/FormHelperText";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import RadioButton from "./RadioButton";

const EMI = ({ values, handleChange, proximaPagina, data, nome_organizacao, setNomeOrganizacao }) => {
	const ind_1 = 0;
	const ind_2 = 1;

	const [estudosError, setEstudosError] = useState(false);
	const [reunioesError, setReunioesError] = useState(false);

	const submitForm = (e) => {
		e.preventDefault();

		setEstudosError(false);
		setReunioesError(false);

		if (!values[data.questoes[ind_1].pergunta]) {
			setEstudosError(true);
		}

		if (!values[data.questoes[ind_2].pergunta]) {
			setReunioesError(true);
		}

		if (
			values[data.questoes[ind_1].pergunta] &&
			values[data.questoes[ind_2].pergunta]
		) {
			proximaPagina();
		}
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Form noValidate onSubmit={submitForm}>
			<h3>{data.dimensao}</h3>

			<div className="col-md-3 col-10">
				<TextField
					className="my-3"
					fullWidth
					variant="standard"
					label="Nome da Organização"
					helperText={
						"Informe a organização caso de deseja calcular para uma organização diferente."
					}
					value={nome_organizacao}
					onChange={(e) => setNomeOrganizacao(e.target.value)}
				/>
			</div>

			<Box className="mt-5">
				<FormControl error={estudosError}>
					<FormLabel className="mb-2">
						{data.questoes[ind_1].pergunta}
					</FormLabel>
					<RadioGroup onChange={handleChange} required>
						<RadioButton
							value={1}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[0]}
							checked={
								values[data.questoes[ind_1].pergunta] === 1
							}
						/>
						<RadioButton
							value={2}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[1]}
							checked={
								values[data.questoes[ind_1].pergunta] === 2
							}
						/>
						<RadioButton
							value={3}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[2]}
							checked={
								values[data.questoes[ind_1].pergunta] === 3
							}
						/>
						<RadioButton
							value={4}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[3]}
							checked={
								values[data.questoes[ind_1].pergunta] === 4
							}
						/>
						<RadioButton
							value={5}
							name={data.questoes[ind_1].pergunta}
							label={data.questoes[ind_1].alternativas[4]}
							checked={
								values[data.questoes[ind_1].pergunta] === 5
							}
						/>
					</RadioGroup>

					{estudosError ? (
						<FormHelperText>Selecione uma opção</FormHelperText>
					) : null}
				</FormControl>
			</Box>

			<Box className="mt-5">
				<FormControl error={reunioesError}>
					<FormLabel className="mb-2">
						{data.questoes[ind_2].pergunta}
					</FormLabel>
					<RadioGroup onChange={handleChange} required>
						<RadioButton
							value={1}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[0]}
							checked={
								values[data.questoes[ind_2].pergunta] === 1
							}
						/>
						<RadioButton
							value={2}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[1]}
							checked={
								values[data.questoes[ind_2].pergunta] === 2
							}
						/>
						<RadioButton
							value={3}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[2]}
							checked={
								values[data.questoes[ind_2].pergunta] === 3
							}
						/>
						<RadioButton
							value={4}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[3]}
							checked={
								values[data.questoes[ind_2].pergunta] === 4
							}
						/>
						<RadioButton
							value={5}
							name={data.questoes[ind_2].pergunta}
							label={data.questoes[ind_2].alternativas[4]}
							checked={
								values[data.questoes[ind_2].pergunta] === 5
							}
						/>
					</RadioGroup>

					{reunioesError ? (
						<FormHelperText>Selecione uma opção</FormHelperText>
					) : null}
				</FormControl>
			</Box>

			<div className="d-flex justify-content-center mt-5">
				<Button
					className="col-4"
					disabled
					color="primary"
					size="lg"
					variant="outlined"
					startIcon={<ArrowBackIosIcon />}
				>
					Voltar
				</Button>

				<span className="col-1"></span>

				<Button
					className="col-4"
					type="submit"
					color="primary"
					size="lg"
					variant="outlined"
					endIcon={<ArrowForwardIosIcon />}
				>
					Próximo
				</Button>
			</div>
		</Form>
	);
};

export default EMI;
